import { useSyncExternalStore } from 'react'

/**
 * L'état du réseau, tel que le navigateur le connaît.
 *
 * ⚠️ `navigator.onLine` dit seulement « une interface réseau est active » — pas « l'API répond ».
 * Il suffit à informer l'agent ; l'état de synchronisation réel, lui, se lit dans la file de
 * propositions (D4), que l'écran de synchro affiche.
 *
 * Un `useSyncExternalStore` plutôt qu'un `useState` + `useEffect` : la valeur vit hors de React,
 * et deux écrans qui l'observent doivent lire la même chose au même instant.
 */
function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

const read = () => navigator.onLine

export function useIsOnline(): boolean {
  // Le troisième argument ne sert qu'au rendu serveur, que D19 écarte : il n'est là que pour
  // satisfaire la signature.
  return useSyncExternalStore(subscribe, read, () => true)
}
